<template>
  <!-- 搜索框 -->
  <el-form
    :inline="true"
    :model="formTree"
    class="demo-form-inline"
    :rules="rules"
    ref="ruleForm"
   
  >
    <el-form-item
      :label="labelText" 
      prop="allCheckKeys"
      class="tree-item"
      label-width="100px"
    >
      <div class="team-tree">
        <el-tree
          :data="data"
          :props="defaultProps"
          @node-click="handleNodeClick"
          node-key="id"
          highlight-current
          :default-expand-all="defaultExpandAll"
          :show-checkbox="isShowCheckBox"
          @check-change="handleCheckChange"
          :filter-node-method="filterNode"
          ref="treeRef"
        >
        </el-tree>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "CbTeamTree",
  props: {
    isShowCheckBox: {
      type: Boolean,
      default: false,
    },
    isShowSearch: {
      type: Boolean,
      default: false,
    },
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    labelText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formTree: { name: "", areaName: "", allCheckKeys: [], allCheckNodes: [] },
      rules: {
        allCheckKeys: [
          { required: true, message: "请选择授权地域", trigger: "change" },
        ],
      },
      nodesList: [],
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
      },
    };
  },

  methods: {
    // 表单验证
    formCheck() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate((valid) => { 
          if (valid) { 
            resolve(true);
          } else {
            reject(false);
          }
        });
      }); 
    },
    onSubmit() {},
    backPage() {
      this.$router.go(-1);
    },
    // 点击勾选框
    handleCheckChange(node) {
      this.publicGetAllCheckNodes();
      this.$emit(
        "handleCheckChange",
        this.formTree.allCheckKeys,
        this.formTree.allCheckNodes
      );
    },
    getTreeNode(node) {
      //获取当前树节点和其父级节点
      if (node.level == 1) {
        this.nodesList.unshift(node.data);
      } else {
        if (node.parent) {
          if (node.parent.data.id) {
            this.nodesList.unshift(node.data);
          }
          this.getTreeNode(node.parent); //递归
        }
      }
    },

    handleNodeClick(node, e) {
      this.nodesList = [];
      this.getTreeNode(e);
      this.$emit("nodeClick", node, this.nodesList);
    },

    // 获取所有选择的节点
    publicGetAllCheckNodes() {
      this.formTree.allCheckKeys = this.$refs.treeRef.getCheckedKeys();
      this.formTree.allCheckNodes = this.$refs.treeRef.getCheckedNodes(); 
    },

    // 设置选中的节点
    publicSetCheckNodes(checkNodeArr) {
      this.$refs.treeRef.setCheckedKeys(checkNodeArr);
    },

    // 过滤输入框的节点
    filterNode(value, data) {
      if (!value) return true;
      return data.name.includes(value);
    },
  },
  created() {
    // this.queryTableData();
  },

  mounted() {},
};
</script>

<style scoped lang="scss">
.custom-tree-node {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.input-search {
  width: 230px;
}
.team-tree {
  height: 400px;
  overflow: auto;
  margin-bottom: 20px;
  width: 400px;
  padding-left: 100px;
}
.tree-item {
  width: 400px; 
}
</style>
